import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { DEFAULT_CONSTANTS } from '@/store/modules/constant/defaults';

const state = {
  constants: {
    ...DEFAULT_CONSTANTS
  },
  initializeState: {
    isLoading: false,
    isInitialized: false,
    lastStatus: null,
    lastErrorMessage: '',
    retryCount: 0
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
